import { IState } from "../..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../../app/store";
import { OperationsReviewSummaryState } from "../ShipmentReconciliationState";
import ShipmentReconciliationService from "../../../app/data/shipment-reconciliation/shipmentReconciliationService";
import { OperationsReviewWorkItemRequest } from "../../../app/data/shipment-reconciliation/models";

const initialState: OperationsReviewSummaryState = {
  loading: false,
  loadingFailed: false,
  loaded: false,
  summary: {
    totalShipmentWorkItems: 0,
    pendingOperationsReview: 0,
    compltedOperationsReview: 0,
    pendingAppliedRate: 0,
    acceptedAppliedRate: 0,
    rejectedAppliedRate: 0
  }
};

const shipmentReconciliationService = ShipmentReconciliationService.getInstance();

export const getOperationsReviewSummarySlice = createSlice({
  name: "getOperationsReviewSummarySlice",
  initialState,
  reducers: {
    resetGetOperationsReviewSummaryState: (state) => initialState,
    getOperationsReviewSummaryLoadingStarted: (state) => {
      state.loading = true;
      state.loadingFailed = false;
      state.loaded = false;
    },
    getOperationsReviewSummarySucceed: (state, { payload }) => {
      state.loaded = true;
      state.loading = false;
      state.loadingFailed = false;
      state.summary = payload;
    },
    getOperationsReviewSummaryLoadingFailed: (state, { payload }) => {
      state.loading = false;
      state.loadingFailed = true;
    },
    changeOperationsReviewSummaryLocally: (state, { payload }) => {
      if (payload.summary) state.summary = payload.summary;
    },
  },
});

export const {
  resetGetOperationsReviewSummaryState,
  getOperationsReviewSummaryLoadingStarted,
  getOperationsReviewSummarySucceed,
  getOperationsReviewSummaryLoadingFailed,
  changeOperationsReviewSummaryLocally,
} = getOperationsReviewSummarySlice.actions;

export const getOperationsReviewSummarySelector = (state: IState) => state.operationsReviewSummary;

export const getOperationsReviewSummaryItems = (
  requestData: OperationsReviewWorkItemRequest,
  onError?: (error: string) => void
): AppThunk => async (dispatch) => {
  dispatch(getOperationsReviewSummaryLoadingStarted());
  const response = await shipmentReconciliationService.getOperationsReviewSummary(requestData);
  if (response.ok() && response.data) {
    dispatch(getOperationsReviewSummarySucceed(response.data));
  } else {
    let error = "Internal Server Error, re-try the action or contact support";
    if (response && response.data && response.data.message) error = JSON.stringify(response.data.message);
    dispatch(getOperationsReviewSummaryLoadingFailed(error));
    onError && onError(error)
  }
};

const getOperationsReviewSummaryReducer = getOperationsReviewSummarySlice.reducer;
export default getOperationsReviewSummaryReducer;